import React, { Fragment, useEffect, useState } from 'react';
import { Col, Row, Card } from 'react-bootstrap';

import { useChat } from '@/Hooks/UseChat';
import useTranslation from '@/Hooks/UseTranslation';

import ProjectLayout from '@/Layouts/MainLayout/ProjectLayout';
import ContentHeader from '@/Layouts/MainLayout/components/ContentHeader';
import ContentBody from '@/Layouts/MainLayout/components/ContentBody';

import ChatSidebar from '@/Components/ChatComponents/ChatSidebar/ChatSidebar';
import ChatContent from '@/Components/ChatComponents/ChatContent/ChatContent';

import './ChatPage.scss'
import MainLayout from '@/Layouts/MainLayout/MainLayout';

const ChatPage: React.FC = (props: any) => {

  const { t } = useTranslation();

  const {
    chat_id
  } = props.match.params

  const { joinChat, currentChat, messages, sendMessage, unsetCurrentChat } = useChat();

  const [ windowWidth, setWindowWidth ] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {

    if (!chat_id) {

      unsetCurrentChat()
    } else if (!currentChat) {

      joinChat([ '', chat_id ]);
    }
  }, [ chat_id ])

  return (
    <MainLayout menuName="chat" subMenuName="chat">
      <ContentHeader title={t('CHAT:Title')}>
        {currentChat && (
          <div className='ul-widget__head-toolbar d-block d-lg-none'>
            <button className="btn btn-secondary" onClick={() => unsetCurrentChat()}>
              <i className="fas fa-fw fa-bars"></i>
            </button>
          </div>
        )}
      </ContentHeader>
      <ContentBody>
        <Row style={{ margin: 0, height: 'calc(100% - 8px)' }}>
          {windowWidth < 992 && (
            <Fragment>
              {!currentChat && (
                <Col className='mb-2' style={{ height: '100%' }}>
                  <Card className='chat-card' style={{ overflow: 'hidden' }}>
                    <ChatSidebar />
                  </Card>
                </Col>
              )}
              {currentChat && (
                <Col className='mb-2' style={{ height: '100%' }}>
                  <Card className='chat-card'>
                    <ChatContent
                      project
                      chat={currentChat}
                      messages={messages}
                      onSendMessage={(message) => sendMessage(message)}
                      disabled={false}
                    />
                  </Card>
                </Col>
              )}
            </Fragment>
          )}
          {windowWidth >= 992 && (
            <Fragment>
              <Col lg={3} className='mb-2' style={{ paddingRight: 0, height: '100%' }}>
                <Card className='chat-card' style={{ overflow: 'hidden' }}>
                  <ChatSidebar />
                </Card>
              </Col>
              <Col lg={9} className='mb-2' style={{ height: '100%' }}>
                <Card className='chat-card'>
                  <ChatContent
                    project
                    chat={currentChat}
                    messages={messages}
                    onSendMessage={(message) => sendMessage(message)}
                    disabled={false}
                  />
                </Card>
              </Col>
            </Fragment>
          )}
        </Row>
      </ContentBody>

      {/* <Modal
        className='modal-chat-sidebar'
        show={windowWidth < 992 && (showModal || !currentChat)}
        onHide={closeChatModal}
      >
        <div style={{ height: '100%' }}>
          <ChatSidebar onSelectChat={() => closeChatModal()} />
        </div>
        <Modal.Footer>
          <button className="btn btn-secondary" onClick={handleClose}>
            <span className="icon-cancelar"></span> {t('CHAT:ChatModalCloseButton')}
          </button>
        </Modal.Footer>
      </Modal> */}
    </MainLayout>
  );
};

export default ChatPage;
